import React from "react"
import Helmet from "react-helmet"
import GatsbyImage from "gatsby-image"
import orangeSymbol from "./../images/mb/orange_symbol.png"
import Link from "gatsby-link"
import nextProjectArrow from "./../images/next-project.png"
import prevProjectArrow from "./../images/previous-project.png"

const MBPostTemplate = ({ data, pathContext }) => {
  const acf = data.wordpressWpMbProject.acf
  const { prev, next } = pathContext
  console.log(acf)

  return (
    <div>
      <Helmet title={`Project '${acf.project_title}' | Moon Beyond Co`} />
      <div className="next-previous-project xs-display-none">
        {/* next project */}
        <div className="next-project">
          <Link to={`/projects/${next.slug}`}>
            <img
              src={nextProjectArrow}
              className="next-project-img"
              alt="Next Project"
            />
            <span>Next Project</span>
            <img
              src={next.acf.thumbnail.localFile.childImageSharp.resolutions.src}
              className="attachment-medium size-medium wp-post-image"
            />
          </Link>
        </div>
        {/* end next project */}
        {/* previous project */}
        <div className="previous-project">
          <Link to={`/projects/${prev.slug}`}>
            <img
              width={300}
              height={187}
              src={prev.acf.thumbnail.localFile.childImageSharp.resolutions.src}
              className="attachment-medium size-medium wp-post-image"
              sizes="(max-width: 300px) 100vw, 300px"
            />
            <img
              src={prevProjectArrow}
              className="previous-project-img"
              alt="Previous Project"
            />
            <span>Previous Project</span>
          </Link>
        </div>
        {/* end previous project */}
      </div>

      {/* Header Image */}
      <section className="project-img">
        <GatsbyImage
          sizes={acf.header_image.localFile.childImageSharp.sizes}
          className="wow fadeIn"
        />
      </section>
      {/* End Header Image */}

      {/* Project Blurb */}
      <section className="no-padding">
        <div className="container">
          <div className="row project-content">
            <div className="col-md-7 col-sm-10 center-col text-center text-med">
              <h6 className="wow fadeIn animated">
                <strong className="black-text">{acf.project_title}</strong>
              </h6>
              <p
                className="wow fadeIn"
                dangerouslySetInnerHTML={{ __html: acf.project_categories }}
              />
            </div>
          </div>
        </div>
      </section>
      {/* End Project Blurb */}
      {/* Project Images */}
      <div className="no-padding-top">
        <div className="project-img">
          {acf.project_images
            .filter((a) => a.localFile)
            .map((a, i) => (
              <GatsbyImage
                sizes={a.localFile.childImageSharp.sizes}
                className="wow fadeIn"
                key={i}
              />
            ))}
        </div>
      </div>
      {/* End Project Images */}
      {/* Description Section */}
      <section className="description">
        <div className="container projectsContainer">
          <div className="row wow fadeIn animated">
            <div className="col-xs-8 col-sm-2 sidebarTitle hidden-xs ">
              <h2>
                <img
                  src={orangeSymbol}
                  className="headingDescription-titleSymbol"
                  alt
                />
                Case Study
              </h2>
              <p>
                Launched: {acf.launch_year}
                <br />
                Project MB-{acf.project_number}
              </p>
            </div>
            <div className="col-xs-4 col-sm-1 sidebarElementColumn hidden-xs">
              <div className="diagonalLine" />
            </div>
            <div className="col-sm-8 projectInfo">
              <h2>{acf.project_title}</h2>
              <p>
                {acf.project_info_line_1}
                <br />
                <i>{acf.project_info_line_2}</i>
                <br />
                {acf.project_info_line_3}
              </p>
              <h3>Project Description</h3>
              <p
                dangerouslySetInnerHTML={{ __html: acf.project_description }}
              />
              <div className="projectInfo__divider" />
              <p className="waterMark">Designed by Moon Beyond Creative</p>
            </div>
          </div>
        </div>
      </section>
      {/* END Description Section */}
    </div>
  )
}

export default MBPostTemplate

export const pageQuery = graphql`
  query blogPostQuery($slug: String!) {
    wordpressWpMbProject(slug: { eq: $slug }) {
      slug
      acf {
        project_title
        project_description
        launch_year
        project_info_line_1
        project_info_line_2
        project_info_line_3
        project_number
        project_categories
        header_image {
          localFile {
            childImageSharp {
              sizes(maxWidth: 1440, quality: 90, toFormat: JPG) {
                ...GatsbyImageSharpSizes_withWebp_noBase64
              }
            }
          }
        }
        project_images {
          localFile {
            childImageSharp {
              sizes(maxWidth: 1440, quality: 90, toFormat: JPG) {
                ...GatsbyImageSharpSizes_withWebp_noBase64
              }
            }
          }
        }
        next_project {
          image
        }
      }
    }
    allWordpressWpMbProject {
      edges {
        node {
          slug
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/templates/MBpost.js